import React from 'react'
import { useLocation } from 'react-router-dom';
import Image from "../../assets/armypatch.png";

const Back = ({title}) => {
    const location = useLocation();
    return (
        <>
            <section className="back" style={{ backgroundImage: `url(${Image})` }}>
                <div className="overlay-back"></div>
                
                <h1>Checkout</h1>
                {/* <h2>Home / Pages / {location.pathname.split('/')[1]}</h2> */}
            </section>
            <div className="margin"></div>
        </>
    )
}

export default Back
